import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          insertion: {
            '{}': {
              inputs: {
                '{}': {
                  records: {
                    '[]': [
                      {
                        '{}': {
                          values: {
                            '{}': {
                              '!when': '2025-04-04',
                              '!sub_coi_exp': {
                                '??': [
                                  {
                                    '@$': 'subrCoiExp',
                                  },
                                  false,
                                ],
                              },
                              '!org_idc_rate': {
                                '??': [
                                  {
                                    '@$': 'subrCoiExp',
                                  },
                                  false,
                                ],
                              },
                              '!org_coi_policy': {
                                '??': [
                                  {
                                    '@$': 'orgCoiPolicy',
                                  },
                                  false,
                                ],
                              },
                              '!org_debar_susp': {
                                '??': [
                                  {
                                    '@$': 'orgDebarSusp',
                                  },
                                  false,
                                ],
                              },
                              '!subj#!subrecip': {
                                '@$': 'subrecipientId',
                              },
                              '!subr_idc_agree': {
                                '??': [
                                  {
                                    '@$': 'subrIdcAgree',
                                  },
                                  false,
                                ],
                              },
                              '!subr_audit_done': {
                                '??': [
                                  {
                                    '@$': 'subrCoiExp',
                                  },
                                  false,
                                ],
                              },
                              '!org_delin_fd_debt': {
                                '??': [
                                  {
                                    '@$': 'orgDelinFdDebt',
                                  },
                                  false,
                                ],
                              },
                              '!org_cost_procs_fam': {
                                '??': [
                                  {
                                    '@$': 'orgCostProcsFam',
                                  },
                                  false,
                                ],
                              },
                              '!org_internal_ctrls': {
                                '??': [
                                  {
                                    '@$': 'orgInternalCtrls',
                                  },
                                  false,
                                ],
                              },
                              '!org_proc_sys_compl': {
                                '??': [
                                  {
                                    '@$': 'orgProcSysCompl',
                                  },
                                  false,
                                ],
                              },
                              '!org_acct_sys_mature': {
                                '??': [
                                  {
                                    '@$': 'orgAcctSysMature',
                                  },
                                  false,
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              modelId: 'snap:!subrecips:!subrecipient_risk_survey',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
